import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { DriverService } from './driver'
import { DialogType, enableDialog } from '@/components/cdialog/dialog'
import i18n from '@/languages/i18n'
import { MouseSetData } from '@libs/types/response'
import { setData } from './data'
import { reactive } from 'vue'
import { speciaBehiver, specialCheck } from '@/define/limit'
import { DeviceManager } from '../device'
import { SpecificItem, SpecificItemAction } from '@libs/types/enum'
import { delay } from '@libs/utils/tools'
import { DevicePid } from '@/define/define'
const { t } = i18n.global

export enum DpiAction {
  DpiActionAdd = 0,
  DpiActionDel = 1,
  DpiActionMod = 2,
}

class BaseSet {
  state = reactive({
    rateValue: 0,
  })

  changeMouseDpi(dpiIndex: number) {
    if (dpiIndex < 0 || dpiIndex > setData.getData().Mouse.DpiList.length - 1) {
      return
    }
    setData.getData().Mouse.DpiIndex = dpiIndex
  }

  changeMouseSet = () => {
    const data = {
      Type: DriverSocketMsgType.MTSetDPIData,
      Data: {
        DpiIndex: setData.getData().Mouse.DpiIndex,
        Action: DpiAction.DpiActionMod,
        Rate: setData.getData().Mouse.Rate,
        DpiData: {
          Dpi: setData.getData().Mouse.DpiList[setData.getData().Mouse.DpiIndex],
          Color: setData.getData().Mouse.DpiColors ? setData.getData().Mouse.DpiColors[setData.getData().Mouse.DpiIndex] : '',
        },
      },
    } as DriverSocketMsg<any>
    DriverService.instance
      .askTypeAndData(data)
      .then(() => {
        enableDialog(t('setting_success'))
      })
      .catch(() => {
        enableDialog(t('setting_failed'), DialogType.notice, false)
      })
  }

  setDPIData = (index: number, Action: DpiAction) => {
    const data = {
      Type: DriverSocketMsgType.MTSetDPIData,
      Data: {
        Rate: setData.getData().Mouse.Rate,
        DpiIndex: index,
        Action: Action,
        DpiData: {
          Dpi: setData.getData().Mouse.DpiList[index],
          Color: setData.getData().Mouse.DpiColors ? setData.getData().Mouse.DpiColors[index] : '',
        },
      },
    } as DriverSocketMsg<any>
    DriverService.instance
      .askTypeAndData<MouseSetData>(data)
      .then((data: MouseSetData) => {
        setData.getData().Mouse = data
        enableDialog(t('setting_success'))
      })
      .catch(() => {
        enableDialog(t('setting_failed'), DialogType.notice, false)
      })
  }

  switchDPI = () => {
    const data = {
      Type: DriverSocketMsgType.MTSwitchDPI,
      Data: {
        DpiIndex: setData.getData().Mouse.DpiIndex,
      },
    } as DriverSocketMsg<any>
    DriverService.instance
      .askTypeAndData(data)
      .then(() => {
        enableDialog(t('change_success'))
      })
      .catch(() => {
        enableDialog(t('change_failed'), DialogType.notice, false)
      })
  }

  pollingRate = (n: number) => {
    const data = {
      Type: DriverSocketMsgType.MTPollingRate,
      Data: { Value: n },
    } as DriverSocketMsg<any>
    DriverService.instance
      .askTypeAndData<number>(data)
      .then((res) => {
        this.state.rateValue = res
        n > 0 ? enableDialog(t('setting_success')) : {}
      })
      .catch(() => {
        n > 0 ? enableDialog(t('setting_failed'), DialogType.notice, false) : {}
      })
  }

  setOrReadSpecificItemRate(n: number) {
    if (!specialCheck(speciaBehiver.ReadWriteRateFromFW, DeviceManager.instance.state.currentPid)) {
      return
    }
    if (n === 0) {
      this.readRate(SpecificItem.Rate)
      return
    }
    enableDialog(t('rate_notice'), DialogType.confirm).then((value: boolean) => {
      if (value) {
        this.writeRate(n, SpecificItem.Rate)
      }
    })
  }

  async setOrReadSpecificItemPollingRate(n: number) {
    if (n === 0) {
      await this.readRate(SpecificItem.PollingRate)
      return
    }
    await this.writeRate(n, SpecificItem.PollingRate)
    const currentPid = DeviceManager.instance.state.currentPid
    if (currentPid == DevicePid.IYXAmber358_24g8k) {
      await delay(300) // amber 无线设备下，直接读取会出现读取值错误的情况，延时300ms后读取
    }
    this.readRate(SpecificItem.PollingRate)
  }

  // 读取回报率
  private async readRate(Item: SpecificItem) {
    const data = {
      Type: DriverSocketMsgType.MTSetOrReadSpecificItem,
      Data: { Item: Item, Action: SpecificItemAction.Read, Value: 0 },
    } as DriverSocketMsg<any>
    const res = await DriverService.instance.askTypeAndData<number>(data)
    this.state.rateValue = res
  }

  // 写回报率
  private writeRate(n: number, Item: SpecificItem): Promise<void> {
    const data = {
      Type: DriverSocketMsgType.MTSetOrReadSpecificItem,
      Data: { Item: Item, Action: SpecificItemAction.Write, Value: n },
    } as DriverSocketMsg<any>
    return DriverService.instance
      .askTypeAndData<number>(data)
      .then((res) => {
        this.state.rateValue = res
        enableDialog(t('setting_success'))
      })
      .catch(() => {
        enableDialog(t('setting_failed'), DialogType.notice, false)
      })
  }

  resetMsg(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const data = {
        Type: DriverSocketMsgType.MTSetReset,
      } as DriverSocketMsg<any>
      DriverService.instance
        .askTypeAndData(data)
        .then(() => {
          enableDialog(t('reset_success'))
          resolve(true)
        })
        .catch(() => {
          enableDialog(t('reset_failed'), DialogType.notice, false)
          reject(false)
        })
    })
  }
}
let baseSet = new BaseSet()
export { baseSet }
